import { replace } from 'utils/navigation/navigate';
import { ThunkMiddleware } from 'redux-thunk';
import { errorNotification } from 'store/general';

export const apiErrorsMiddleware: ThunkMiddleware = (store) => (next) => (action) => {
  if (!action.error || !(action.payload instanceof Error)) {
    return next(action);
  }

  const badRequestHandler = () => {
    return next(action);
  };

  const notFoundHandler = () => {
    if (action.meta && action.meta.ignoreNotFoundError) {
      return next(action);
    } else {
      store.dispatch(errorNotification('ERROR.NOT-FOUND'));
      return replace('/not-found');
    }
  };

  const forbiddenHandler = () => {
    return next(action);
  };

  const unauthorizedHandler = () => {
    // 401 responses should just pass through without showing error messages
    // The refresh logic in customFetch.middleware will handle retries
    // If all retries fail, the user will be redirected to login
    return next(action);
  };

  const technicalBreakHandler = () => {
    window.location.reload();
  };

  const genericErrorHandler = () => {
    store.dispatch(errorNotification('ERROR.GENERAL-ERROR'));
    return next(action);
  };

  const errorHandlers = {
    400: badRequestHandler,
    401: unauthorizedHandler,
    403: forbiddenHandler,
    404: notFoundHandler,
    503: technicalBreakHandler,
  };

  if (errorHandlers[action.payload.status]) {
    return errorHandlers[action.payload.status]();
  } else {
    return genericErrorHandler();
  }
};
